import { useZero } from "@rocicorp/zero/react";
import { useState, useSyncExternalStore } from "react";
import { sharedMutators } from "../../shared/mutators";
import { useIsNarrow } from "./useIsNarrow";

const KEY = "sidebarCollapsed";

const listeners = new Set<() => void>();

function notify() {
  for (const listener of listeners) listener();
}

function subscribe(callback: () => void) {
  listeners.add(callback);
  const onStorage = (e: StorageEvent) => {
    if (e.key === KEY || e.key === null) callback();
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(callback);
    window.removeEventListener("storage", onStorage);
  };
}

function getSnapshot() {
  const preference = localStorage.getItem(KEY);
  if (preference === "on") return true;
  if (preference === "off") return false;
  return null;
}

function setCollapsed(next: boolean) {
  localStorage.setItem(KEY, next ? "on" : "off");
  notify();
}

export function useSidebarCollapsed(): [boolean, (next: boolean) => void] {
  const z = useZero();
  const isNarrow = useIsNarrow();
  const preference = useSyncExternalStore(subscribe, getSnapshot, () => null);
  const [narrowPinnedOpen, setNarrowPinnedOpen] = useState(false);
  if (!isNarrow && narrowPinnedOpen) setNarrowPinnedOpen(false);
  const setter = (next: boolean) => {
    if (isNarrow) setNarrowPinnedOpen(!next);
    else setCollapsed(next);
    z.mutate(
      sharedMutators.setSidebarCollapsed({
        surface: "sidebar",
        collapsed: next,
      })
    );
  };
  return [isNarrow ? !narrowPinnedOpen : preference === true, setter];
}
